import CommandObject from "./CommandObject";

export default class UpdateShapeCommandObject extends CommandObject {
  constructor(undoHandler, oldData) {
    super(undoHandler, true);
    this.oldValue = oldData;
  }

  toString() {
    return ["Change", this.targetObject.type].join(' ')
  }
  
  /* override to return true if this command can be executed,
   *  e.g., if there is an object selected
   */
  canExecute() {
    return this.undoHandler.getState().selectedObj !== null; // global variable for selected
  }

  /* override to execute the action of this command.
   * pass in false for addToUndoStack if this is a command which is NOT
   * put on the undo stack, like Copy, or a change of selection or Save
   */
  execute() {
    let state = this.undoHandler.getState()
    let selectedObj = state.shapesMap[state.selectedShapeId];
    if (selectedObj) {
      this.targetObject = selectedObj;
      this.newValue = {
        initCoords: selectedObj.initCoords,
        finalCoords: selectedObj.finalCoords
      };

      // Note that this command object must be a NEW command object so it can be
      // registered to put it onto the stack
      if (this.addToUndoStack) this.undoHandler.registerExecution(this);
    }
  }

  /* override to undo the operation of this command
   */
  undo() {
    this.undoHandler.updateShapeProps(this.targetObject.id, this.oldValue);
  }

  /* override to redo the operation of this command, which means to
   * undo the undo. This should ONLY be called if the immediate
   * previous operation was an Undo of this command. Anything that
   * can be undone can be redone, so there is no need for a canRedo.
   */
  redo() {
    this.undoHandler.updateShapeProps(this.targetObject.id, this.newValue);
  }

  /* override to return true if this operation can be repeated in the
   * current context
   */
  canRepeat() {}

  /* override to execute the operation again, this time possibly on
   * a new object. Thus, this typically uses the same value but a new
   * selectedObject.
   */
  repeat() {}
}